import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Wenn angegeben, wird hiermit das zugrunde liegende DOM-Element ermittelt..
     */
    elementRef?: (ref: HTMLAnchorElement) => void,

    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Titel Text.
     */
    title?: string,

    /**
     * Name des Icons welches angezeigt werden soll.
     */
    icon?: string,

    /**
     * Die Farbe des Icons.
     */
    iconColor?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Angabe, ob das Item abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e?: MouseEvent) => void
}

export class ToolBarItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { text, title, icon, iconColor, linkTo, isDisabled, onClick } = this.props;
        const content: JSX.Element[] = [];
        const classNames: string[] = ["toolbar_item"];

        if (isDisabled)
            classNames.push("toolbar_item--disabled");

        if (icon != null)
            content.push(
                <i
                    style={{
                        color: iconColor
                    }}
                    className={`toolbar_item_icon mdi mdi-${icon}`}></i>
            );

        if (text != null)
            content.push(<span className="toolbar_item_text">{text}</span>);

        return (
            <OptionalLink
                anchorRef={this.props.elementRef}
                className={classNames.join(" ")}
                title={title}
                to={this.props.linkTo}
                onClick={this.onClick}>
                {content}
            </OptionalLink>
        );
    }
}